import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import IAnalysis from '../interface/Analysis/IAnalysis';

export default class DealAnalysisService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/deal/analysis/");
  }

  public getByDealId = async (dealId: number): Promise<IAnalysis> => await this.GET(String(dealId));
}